var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16659 1.85417C8.16659 2.4985 7.64425 3.02083 6.99992 3.02083C6.35559 3.02083 5.83325 2.4985 5.83325 1.85417C5.83325 1.20983 6.35559 0.6875 6.99992 0.6875C7.64425 0.6875 8.16659 1.20983 8.16659 1.85417Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.02075V5.27075",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10.75C8.75 10.75 8.2 11.3333 7 11.3333C5.8 11.3333 5.25 10.75 5.25 10.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04175 8.5415C4.90368 8.5415 4.79175 8.42958 4.79175 8.2915C4.79175 8.15343 4.90368 8.0415 5.04175 8.0415",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04175 8.5415C5.17982 8.5415 5.29175 8.42958 5.29175 8.2915C5.29175 8.15343 5.17982 8.0415 5.04175 8.0415",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95825 8.5415C8.82018 8.5415 8.70825 8.42958 8.70825 8.2915C8.70825 8.15343 8.82018 8.0415 8.95825 8.0415",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95825 8.5415C9.09632 8.5415 9.20825 8.42958 9.20825 8.2915C9.20825 8.15343 9.09632 8.0415 8.95825 8.0415",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.3125V7.3125C1.5 6.20793 2.39543 5.3125 3.5 5.3125H10.5C11.6046 5.3125 12.5 6.20793 12.5 7.3125V11.3125C12.5 12.4171 11.6046 13.3125 10.5 13.3125H3.5C2.39543 13.3125 1.5 12.4171 1.5 11.3125Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.4969ed88cca5dce4dd3d8fb79587c7c0.svg";
export { ForwardRef as ReactComponent };